import React from 'react';

/**
 * Reusable tabs menu with shared styling.
 *
 * tabs:
 * - key: unique key
 * - label: React node
 * - badge: optional badge value
 * - badgeClassName: optional badge class name
 */
export default function TabsMenu({
  tabs = [],
  activeKey,
  onChange,
  ariaLabel,
  className = '',
}) {
  return (
    <div className={`tabs-menu${className ? ` ${className}` : ''}`} role="tablist" aria-label={ariaLabel}>
      {tabs.map((tab) => {
        const isActive = tab.key === activeKey;
        const hasBadge = tab.badge !== undefined && tab.badge !== null && tab.badge !== false;
        return (
          <button
            key={tab.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`tabs-menu__tab${isActive ? ' is-active' : ''}`}
            onClick={() => onChange?.(tab.key)}
          >
            <span className="tabs-menu__label">{tab.label}</span>
            {hasBadge && (
              <span className={`tabs-menu__count${tab.badgeClassName ? ` ${tab.badgeClassName}` : ''}`}>
                {tab.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
